export const LARGE = 'LARGE';